import getConfig from 'next/config'
import KP5CONSTANTS from './constants'
const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()

/* Client Side */

export const adSsoStartConnect = async (settings) => {
  try {
    const apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/adSso/connect`
    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(settings)
    })
    return response
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const adSsoFinishConnect = async () => {
  try {
    const apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/adSso/finishConnect`
    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `fetch adSsoFinishConnect failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    console.log('PUT /api/v1/adSso/finishConnect responseJSON:', responseJSON)
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}
export const adSsoStartDisconnect = async () => {
  try {
    const apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/adSso/disconnect`
    const response = await fetch(apiUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `fetch adSsoStartDisconnect failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    console.log('PUT /api/v1/adSso/disconnect responseJSON:', responseJSON)
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

/* Server Side */

export const getAdSsoSettings = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/adSso/settings`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })

    if (!response.ok) {
      throw `getAdSsoSettings failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    console.log('getAdSsoSettings responseJSON', responseJSON)
    return responseJSON
  } catch (err) {
    return Error(err)
  }
}

export const startAuth = async (cookie) => {
  try {
    const apiUrl = `${serverRuntimeConfig.authPermApiBaseUrl}/api/v1/sso/startAuth/sa`
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: cookie && {
        Cookie: cookie
      }
    })
    if (!response.ok) {
      throw `fetch startAuth failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.error(err)
    return Error(err)
  }
}

export const authConsumeSA = async (cookie, query = null) => {
  try {
    let apiUrl = `${serverRuntimeConfig.authPermApiBaseUrl}/api/v1/sso/authConsume/sa`

    // Add any query params initially present in request
    // Primarily used to pass errorCodes to BE api
    if (query) {
      apiUrl += `?${new URLSearchParams(query)}`
    }
    const headers = { 'Content-Type': 'application/json' }
    if (cookie) {
      headers['Cookie'] = cookie
    }
    const rawResponse = await fetch(apiUrl, {
      method: 'POST',
      headers: headers
    })
    const authConsumeResponseData = await rawResponse.json()
    return { rawResponse, authConsumeResponseData }
  } catch (err) {
    console.error(err)
    return Error(err)
  }
}

export const authConsumeCorpAd = async (cookie, code, email) => {
  try {
    let apiUrl = `${serverRuntimeConfig.authPermApiBaseUrl}/api/v1/sso/authConsume/corpAd`

    const headers = { 'Content-Type': 'application/json' }
    if (cookie) {
      headers['Cookie'] = cookie
    }
    const rawResponse = await fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        code,
        email
      })
    })
    const authConsumeResponseData = await rawResponse.json()
    return { rawResponse, authConsumeResponseData }
  } catch (err) {
    console.error(err)
    return Error(err)
  }
}

export const authConsumeAD = async (cookie, query = null) => {
  try {
    let apiUrl = `${serverRuntimeConfig.authPermApiBaseUrl}/api/v1/sso/authConsume/ad`
    const headers = { 'Content-Type': 'application/json' }

    // Add any query params initially present in request
    // Primarily used to pass errorCodes to BE api
    if (query) {
      apiUrl += `?${new URLSearchParams(query)}`
    }

    if (cookie) {
      headers['Cookie'] = cookie
    }
    const rawResponse = await fetch(apiUrl, {
      method: 'POST',
      headers: headers
    })
    // if (!rawResponse.ok) {
    //   throw `fetch authConsumeSA failed: ${rawResponse.status} ${rawResponse.statusText}`
    // }
    const authConsumeResponseData = await rawResponse.json()
    return { rawResponse, authConsumeResponseData }
  } catch (err) {
    console.error(err)
    return Error(err)
  }
}

export const passwordConfirmConsumeSA = async (cookie, confirm_token, state) => {
  try {
    const apiUrl = `${serverRuntimeConfig.authPermApiBaseUrl}/api/v1/sso/passwordConfirmConsume/sa`
    const headers = { 'Content-Type': 'application/json' }
    if (cookie) {
      headers['Cookie'] = cookie
    }
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        confirm_token,
        state
      })
    })
    if (!response.ok) {
      throw `fetch passwordConfirmConsumeSA failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.error(err)
    return Error(err)
  }
}

/**
 * @returns {string|null} - Returns the idp type of the account, or returns null if AMS response code couldn't be mapped to an idp name.
 * If the accountId is not found, it will return a default of B2B_SAMSUNG_ACCOUNT.
 */
export const getAmsLoginType = async (accountId) => {
  try {
    const apiUrl = `${
      publicRuntimeConfig.knoxApiGatewayBaseUrlEU
    }/ams/v1/customers/logintype?accountId=${encodeURIComponent(accountId)}`
    const response = await fetch(apiUrl, {
      method: 'GET'
    })
    const responseJSON = await response.json()

    /**
     * TODO: After 1.57.a release, we can change the idpType variable to fallback to null instead of responseJSON. This responseJSON default val
     * is currently here to ensure backwards compatibility, as before 1.57.a, the AMS API returned the idpType by name/string instead of the enum code.
     * This cleanup will also allow us to remove validIdpType, as idpType will already be null if its not valid.
     */
    const idpType = KP5CONSTANTS.AMS_IDP_TYPE_CODE_TO_NAME[responseJSON] ?? responseJSON
    const validIdpType =
      Object.keys(KP5CONSTANTS.AMS_IDP_TYPE_CODE_TO_NAME).includes(idpType) ||
      Object.values(KP5CONSTANTS.AMS_IDP_TYPE_CODE_TO_NAME).includes(idpType)

    if (!validIdpType) {
      console.warn('Failed to resolve idp type from /ams/v1/customers/logintype')
      return { ok: response.ok, responseJSON: null }
    }

    return { ok: response.ok, responseJSON: idpType }
  } catch (err) {
    console.error(err)
    return Error(err)
  }
}
